import { IconButton, TextField } from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { debounce } from 'lodash';
import { InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

import { setFetchParamsAction } from './types';

export const SearchBox = () => {
  const searchInputRef = useRef();
  const dispatch = useDispatch();

  const handleSearch = (searchTerm: string): void => {
    dispatch(setFetchParamsAction({ searchTerm }));
  };

  const handleSearchDebounced = debounce((search) => handleSearch(search), 600);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row-reverse',
        marginLeft: 'auto',
        padding: 15,
      }}
    >
      <TextField
        type="search"
        size="small"
        placeholder="Search"
        inputRef={searchInputRef}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="clear"
                onClick={(): void => {
                  if (searchInputRef.current) {
                    searchInputRef.current.value = '';
                  }
                  handleSearch('');
                }}
                size="small"
              >
                <ClearIcon fontSize="inherit" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>): void =>
          handleSearchDebounced(event.target.value)
        }
        style={{
          width: 350,
        }}
      />
    </div>
  );
};
